/**
 * 广告相关逻辑
 */
import { mapState } from 'vuex';

const AdLinkTypeMap = {
  OUTER: '1',
  INNER: '2',
  MINPROGRAM: '3',
};
const AdMiniprogramTransTypeMap = {
  TRANS: '1',
  MODAL: '2',
};

export default {
  data() {
    return {
      AdLinkTypeMap,
      AdMiniprogramTransTypeMap,
    };
  },
  computed: {
    ...mapState({
      appletPicConfig: (state) => state.config.appletPicConfig,
      vip_endtime: (state) => state.vip_endtime,
      is_vip: (state) => state.is_vip,
    }),
    sex() {
      return this.$store.state.sex;
    },
    sexText() {
      return this.sex === 2 ? '女' : '男';
    },
    isVipTime() {
      return new Date(Date.parse(this.vip_endtime.replace(/-/g, '/'))).getTime();
    },
  },
  methods: {
    // adData 广告信息 reportData [type, position]埋点上报信息
    handleMiniprogramAd(adData) {
      // 新增逻辑
      const targetMinprogram = this.appletPicConfig.find((item) => item.applet_id === adData.miniprogram);
      if (adData.miniprogramTransType === AdMiniprogramTransTypeMap.TRANS) {
        location.href = targetMinprogram.applet_trans_url;
      }
      if (adData.miniprogramTransType === AdMiniprogramTransTypeMap.MODAL) {
        this.$RaiseMessage.alert(targetMinprogram.applet_modal_pic, '');
      }
    },
  },
  mounted() {
    if (!this.appletPicConfig?.length) {
      this.$store.dispatch('getAppletData')
    }
  },
};
